import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoaderService } from "../../service/loader.service";
import { Message } from "../../service/message.service";
import { RestService } from "../../service/rest.service";

@Component({
  selector: "app-bando-details",
  templateUrl: "./bando-details.component.html",
  styles: [],
  standalone: false,
})
export class BandoDetailsComponent implements OnInit {
  constructor(
    private router: Router,
    private message: Message,
    private rest: RestService,
    private loader: LoaderService
  ) {}
bandoDetails :any= {}
  files = [{ ex: 'PDF', name: 'all.pdf', w: '20MB' }, { ex: 'PNG', name: 'pc.png', w: '20MB' }, { ex: 'ZIP', name: 'zip.zip', w: '20MB' }, { ex: 'JPG', name: 'jpg.jpg', w: '20MB' },, { ex: 'JPG', name: 'jpg.jpg', w: '20MB' }, { ex: 'JPG', name: 'jpg.jpg', w: '20MB' }, { ex: 'JPG', name: 'jpg.jpg', w: '20MB' }, { ex: 'JPG', name: 'jpg.jpg', w: '20MB' }, ]

ngOnInit(): void {
    window.location.pathname.split('/')[2]
    this.loader.on()
    this.rest.get('/notice/' + window.location.pathname.split('/')[2]).subscribe({
      next:(res:any)=> {
        res.endDate = new Date(res.endDate).getDate() + '/' + (new Date(res.endDate).getMonth()+1) + '/' + new Date(res.endDate).getFullYear()
        this.bandoDetails = res
        this.loader.off()
      },
      error:(value:any)=> {
          this.loader.off()
      },
    })
  }

  confirmData(){}

}
